import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import '@/assets/stylus/index.styl'
// import '../public/config'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import cn from './assets/js/cn.js'
import en from './assets/js/en.js'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'CN',
  messages: {
    "CN": cn,
    "EN": en
  }
})

Vue.config.productionTip = false

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {ak: '6dR2nRDTGPfgwVQoqr2ZMiBfHwmhXTyF'})

import {get, post} from './assets/js/http.js'
Vue.prototype.$get = get
Vue.prototype.$post = post

import {mapGetters, mapActions} from 'vuex'
Vue.mixin({
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['pageWidth', 'language', 'bannerList'])
  },
  methods:{
    getData () {},
  },
  watch: {
    language () {
      this.getData()
    },
    $route () {
      this.getData()
    }
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')